<template>
  <component
    :is="claimsShowComponent"
    v-if="projectsStore.project"
    :project-id="projectId"
  />
</template>

<script setup lang="ts">
import useBoqLockRedirect from '@/composables/useBoqLockRedirect';
import { useProjectsStore } from '@/store/projects';
import { computed, watch } from 'vue';
import { useRouter } from 'vue-router';
import ProgressClaimsShow from './ProgressClaimsShow.vue';
import ProgressClaimsShowLite from './ProgressClaimsShowLite.vue';

const props = defineProps<{
  projectId: string;
}>();

useBoqLockRedirect();

const projectsStore = useProjectsStore();
const router = useRouter();

watch(() => props.projectId, (newValue, oldValue) => {
  if(newValue !== oldValue) {
    router.push({ name: 'ProgressClaimsIndex' });
  }
});

const claimsShowComponent = computed(() => {
  return projectsStore.project?.feature_flag_progress_claims_lite ? ProgressClaimsShowLite : ProgressClaimsShow;
});
</script>
